import * as React from 'react';
import * as styles from './PromoCard.css';

interface IPromoCardProps {
  image: React.ReactNode;
  moreInfo: React.ReactNode;
  menu: React.ReactNode;
}

export function PromoCard({ image, moreInfo, menu }: IPromoCardProps) {
  return (
    <article className={styles['container']} data-testid="PromoCard">
      <div className={styles['image']}>{image}</div>
      <div className={styles['more']}>{moreInfo}</div>
      <div className={styles['menu']}>{menu}</div>
    </article>
  );
}
